import {createSlice, createAction} from '@reduxjs/toolkit';
import {HYDRATE} from 'next-redux-wrapper';
import {AppState, Competition} from '@jobseeker/common-core/types';
import {COMPETITION_SLICE_NAME} from '@jobseeker/common-core/constants';

const initialState: Competition = {
  timelines: {
    registration: {
      startDate: '',
      endDate: '',
    },
    round1: {
      startDate: '',
      endDate: '',
    },
    round2: {
      startDate: '',
      endDate: '',
    },
    round3: {
      startDate: '',
      endDate: '',
    },
  },
  status: 'idle',
  error: null,
};

const HyDrate = createAction<AppState>(HYDRATE);

const timelineSlice = createSlice({
  name: COMPETITION_SLICE_NAME,
  initialState,
  reducers: {
    set_timeline_data: (state, action) => {
      state.timelines = action.payload?.competition;
    },
  },

  extraReducers(builder) {
    builder.addCase(HyDrate, (state, action) => {
      if (!action.payload.competition) {
        return state;
      }
      state.timelines = action.payload?.competition?.timelines;
    });
  },
});

export const {set_timeline_data} = timelineSlice.actions;

const reducer = timelineSlice.reducer;

export {reducer, initialState};
